import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Content/Image';
import DiagramImage from '../Content/DiagramImage';
import VimeoStream from '../Content/VimeoStream';
import VideoRestrictedMessage from '../Global/Messages/VideoRestrictedMessage';

const DrillHero = ({ content, access, loggedInUserId }) => {
  let heroContent;
  let imageSrc;

  if ('stream' in content && content.stream.data.iframe) {
    if (access.canIAccess === true) {
      heroContent = (
        <div className="hero-container">
          <VimeoStream streamId={content.stream.data.stream_id} title={content.stream.data.title} />
        </div>
      );
    } else {
      if (content.stream.data.thumbnail_lg) {
        imageSrc = { src: content.stream.data.thumbnail_lg };
      } else {
        imageSrc = content.image.data;
      }

      heroContent = (
        <div className="hero-container">
          <VideoRestrictedMessage access={access} />
          <Image image={imageSrc} />
        </div>
      );
    }
  } else if ('image' in content && content.image.data.src) {
    if (content.image.data.type === 'pitch-diagram-snapshot-image') {
      heroContent = <div className="hero-container"><DiagramImage image={content.image.data} loggedInUserId={loggedInUserId} authorId={content.author.id} /></div>;
    } else {
      heroContent = <div className="hero-container"><Image image={content.image.data} /></div>;
    }
  }

  return (
    <div>
      {heroContent}
    </div>
  );
};

DrillHero.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  access: PropTypes.object,
  loggedInUserId: PropTypes.number,
};

export default DrillHero;



// WEBPACK FOOTER //
// ./library/app/components/Drill/DrillHero.js